/**
 * 文本处理器
 * 实现ContentProcessor接口，处理纯文本内容
 *
 * 核心功能：
 * 1. 解析和结构化文本
 * 2. 提取和处理段落
 * 3. 检测语言和分析文本特征
 * 4. 提供上下文分析功能
 */
import { ContentType } from '@readsavor/types';
import { splitIntoParagraphs as splitText } from '@readsavor/utils';
import { detectLanguage as detectLang } from '@readsavor/utils';
import { getTextStats as getStats } from '@readsavor/utils';
/**
 * 文本处理器实现
 * 处理纯文本内容，实现ContentProcessor接口
 *
 * 作为适配器，将utils包中的工具函数适配为ContentProcessor接口
 */
export class TextProcessor {
    /**
     * 解析文本内容
     * @param content 纯文本内容
     * @returns 解析后的内容结构
     */
    async parseContent(content) {
        // 验证输入
        if (!content || typeof content !== 'string') {
            return {
                type: ContentType.TEXT,
                content: '',
                // 存储段落数据在metadata中
                metadata: {
                    paragraphs: [],
                },
            };
        }
        // 分割文本为段落
        const paragraphs = this.splitIntoParagraphs(content);
        // 返回解析结果
        return {
            type: ContentType.TEXT,
            content: content,
            // 存储段落数据在metadata中
            metadata: {
                paragraphs,
            },
        };
    }
    /**
     * 将内容分割成段落
     * @param content 待分割的内容
     * @returns 段落数组
     */
    splitIntoParagraphs(content) {
        return splitText(content);
    }
    /**
     * 检测文本语言
     * @param content 文本内容
     * @returns 检测到的语言代码
     */
    detectLanguage(content) {
        return detectLang(content);
    }
    /**
     * 获取文本统计信息
     * @param content 文本内容
     * @returns 统计信息
     */
    getTextStats(content) {
        return getStats(content);
    }
}
//# sourceMappingURL=TextProcessor.js.map